module.exports = __webpack_public_path__ + "static/media/CognizantLogo.1ab0c6d7.png";